<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{t('Expired modal heading text (Signing Page) - Document expired')}}</h4>
    </div>
    <form [formGroup]="postponedForm" (ngSubmit)="onSubmit()">
        <div class="modal-body">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                    <div class="form-group">
                        <p class="font-small-3">{{t('Request due date extension text (Signing Page) - This document was available until dueDate. Still you can request to extend the deadline',{dueDate:dueDate})}}</p>
                        <label for="basicTextarea">{{t('Your message text (Signing Page) - Your message')}}</label>
                        <fieldset class="form-group">
                            <textarea class="form-control" id="basicTextarea" rows="3" formControlName="message" [class.is-invalid]="submitted && postponedForm.get('message')?.invalid" placeholder="{{t('Enter your message here text (Signing Page) - Enter your message here')}}"></textarea>
                            <div class="invalid-feedback" *ngIf="submitted && postponedForm.get('message')?.invalid">
                                {{t('Message required validation text (Signing Page) - Your message is required')}}
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer px-1 border-top">
            <button type="submit" class="btn btn-primary" rippleEffect>
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                {{t('Send request button (Signing Page) - Send request')}}
            </button>
        </div>
    </form>
</ng-container>